(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallResult', PhoneCallResult);

    PhoneCallResult.$inject = ['$resource'];

    function PhoneCallResult ($resource) {
        var resourceUrl =  'api/phone-call-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
